import { useTranslation } from "@thyra/landing-i18n";
import { BackgroundBeams } from "./ui/BackgroundBeams";
import { getAppUrl } from "../env";

export function FooterAgenticCta() {
  const { t } = useTranslation("sections");
  return (
    <section
      aria-labelledby="footer-agentic-cta-heading"
      className="relative w-full overflow-hidden rounded-3xl border border-primary/25 bg-gradient-to-b from-[var(--color-primary-muted)] via-card to-card px-6 py-14 text-center shadow-sm dark:border-primary/20 dark:from-[#0b0c10] dark:via-[#0b0c10] dark:to-[#0b0c10] dark:shadow-none sm:px-10 sm:py-16"
    >
      <BackgroundBeams className="z-0 opacity-45 dark:opacity-55" />
      <div
        className="pointer-events-none absolute inset-0 z-0 bg-[radial-gradient(ellipse_70%_55%_at_50%_-10%,rgba(50,102,218,0.14),transparent_65%)] dark:bg-[radial-gradient(ellipse_70%_55%_at_50%_-10%,rgba(50,102,218,0.22),transparent_65%)]"
        aria-hidden
      />

      <div className="relative z-10 mx-auto max-w-xl">
        <h2
          id="footer-agentic-cta-heading"
          className="text-balance text-2xl font-semibold tracking-tight text-foreground sm:text-3xl"
        >
          {t("footerCta.title")}
        </h2>
        <p className="mt-4 text-pretty text-base leading-relaxed text-muted-foreground">
          {t("footerCta.description")}
        </p>

        <a
          href={getAppUrl()}
          className="mt-9 inline-flex h-11 items-center justify-center rounded-full border border-primary/40 bg-background px-8 text-sm font-medium text-foreground transition-colors hover:border-primary/60 hover:bg-primary/10 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/40 dark:border-primary/35 dark:bg-zinc-950/90 dark:text-white dark:hover:border-primary/55 dark:hover:bg-primary/10"
        >
          {t("footerCta.button")}
        </a>
        <p className="mt-3 text-sm text-muted-foreground">
          {t("footerCta.note")}
        </p>
      </div>
    </section>
  );
}
